import * as CryptoJS from 'crypto-js';
import {KEYS} from './keys';

const ENV = KEYS.PROD;

export class Constants {
    public static endpoints = {
        login: 'authorization-server/oauth/token',
        sendOrder: 'billing/charge',
        validEmail: 'authorization-server/user/username-available',
        resetPassword: 'authorization-server/users/passwordRecovery',
        createAccount: 'authorization-server/user/register',
        changePassword: 'authorization-server/users/changePassword',
        infoUser: 'authorization-server/user/info',
        checkCode: 'billing/coupon',
        checkMovil: 'billing/sms',
        register: 'billing/register'
    };

    public static configSession = {
        userK: 'U2FsdGVkX1/okExN0uUO9sFZfQw7M1HAyJU8b4cF9VqrzQ5YVIutrlkhUFFG6XDG',
        userP: 'f3f3ferf34rfrf$··$%34',
        passK: ENV.KEY,
        passP: '1234tf34rfd3f3rf3fr&%··$&/(/&'
    };

    public static BACKOFFICE_URL = ENV.BASE_URL_BACKOFFICE;

    public static KEY = '1234567890ABCDEF';
    public static HEADERS = ['xha0xli0ne1', 'xha0xli0ne3', 'xha0xli0ne2', 'xha0xli0ne5', 'xha0xli0ne4'];

    public static LOGIN_KEY = 'JJQUfgm0i5MJ70NI';
    public static LOGIN_IV = 'uxQKO3FiCiht0uVU';

    public static typePersonalMonth = 1;
    public static typePersonalAnual = 2;
    public static typeCompanyMonth = 3;
    public static typeCompanyAnual = 4;
    public static typeCompanyIntegration = 5;
    public static planMensual = 6;
    public static planAnual = 7;
    public static planMensualEmpresa = 8;

    public static defaultComplementsP = [
        {
            isAdd: false,
            name: 'Foto INE+Comparación de firma',
            quantity: 1,
            description: '$10.00 MXP por transacción',
            price: 10,
            currency: 'MXP'
        },
        {
            isAdd: false,
            name: 'Foto INE',
            quantity: 1,
            description: '$3.00 MXP por transacción',
            price: 3,
            currency: 'MXP'
        },
        {
            isAdd: false,
            name: 'Foto INE+Comparación de firma+comparación de videofirma vs foto INE',
            quantity: 1,
            description: '$12.00 MXP por transacción',
            price: 12,
            currency: 'MXP'
        },
        {
            isAdd: false,
            name: 'OTP vía WhatsApp',
            quantity: 1,
            description: '$3.00 MXP por transacción',
            price: 3,
            currency: 'MXP'
        },
        {
            isAdd: false,
            name: 'Versión WEB',
            quantity: 1,
            description: '$10.00 MXP por transacción',
            price: 10,
            currency: 'MXP'
        },
        {
            isAdd: false,
            name: 'Foto INE+Comparación de firma+comparación de videoacuerdo vs foto INE',
            quantity: 1,
            description: '$12.00 MXP por transacción',
            price: 12,
            currency: 'MXP'
        },
        {
            isAdd: false,
            name: 'Constancia de conservación en USA',
            quantity: 1,
            description: '$5.00 MXP por transacción',
            price: 5,
            currency: 'MXP'
        },
        {
            isAdd: false,
            name: 'Foto INE+Comparación de firma+comparación de videoacuerdo y de videofirma vs foto INE',
            quantity: 1,
            description: '$14.00 MXP por transacción',
            price: 14,
            currency: 'MXP'
        },
        {
            isAdd: false,
            name: 'Constancia de conservación en Blockchain (Etherium)',
            quantity: 1,
            description: '$7.00 MXP por transacción',
            price: 7,
            currency: 'MXP'
        }
    ];

    public static defaultComplements = [
        {
            isAdd: false,
            name: 'Foto INE+Comparación de firma',
            quantity: 1,
            description: '$10.00 MXP por transacción',
            price: 10,
            currency: 'MXP'
        },
        {
            isAdd: false,
            name: 'Foto INE',
            quantity: 1,
            description: '$3.00 MXP por transacción',
            price: 3,
            currency: 'MXP'
        },
        {
            isAdd: false,
            name: 'Foto INE+Comparación de firma+comparación de videofirma vs foto INE',
            quantity: 1,
            description: '$12.00 MXP por transacción',
            price: 12,
            currency: 'MXP'
        },
        {
            isAdd: false,
            name: 'OTP vía WhatsApp',
            quantity: 1,
            description: '$3.00 MXP por transacción',
            price: 3,
            currency: 'MXP'
        },
        {
            isAdd: false,
            name: 'Foto INE+Comparación de firma+comparación de videoacuerdo vs foto INE',
            quantity: 1,
            description: '$12.00 MXP por transacción',
            price: 12,
            currency: 'MXP'
        },
        {
            isAdd: false,
            name: 'Constancia de conservación en USA',
            quantity: 1,
            description: '$5.00 MXP por transacción',
            price: 5,
            currency: 'MXP'
        },
        {
            isAdd: false,
            name: 'Foto INE+Comparación de firma+comparación de videoacuerdo y de videofirma vs foto INE',
            quantity: 1,
            description: '$14.00 MXP por transacción',
            price: 14,
            currency: 'MXP'
        },
        {
            isAdd: false,
            name: 'Constancia de conservación en Blockchain (Etherium)',
            quantity: 1,
            description: '$7.00 MXP por transacción',
            price: 7,
            currency: 'MXP'
        }
    ];

    static decryptData(data, key): string {
        const plainData = CryptoJS.AES.decrypt(data.toString(), key);
        return plainData.toString(CryptoJS.enc.Utf8);
    }

    static getdecryptData(data, key): string {
        const decData = CryptoJS.enc.Base64.parse(data).toString(CryptoJS.enc.Utf8);
        const bytes = CryptoJS.AES.decrypt(decData, key).toString(CryptoJS.enc.Utf8);
        return JSON.parse(bytes);
    }

}

export const goTopHeader = () => {
    (document.getElementById('header-landing') as HTMLElement).scrollIntoView();
};

export const redirectToLink = (link: string) => {
    window.open(link, '_blank');
};

export const isIPhone = () => {
    return (
        navigator.userAgent.indexOf('iPhone') > 0 ||
        navigator.userAgent.indexOf('iPad') > 0 ||
        (navigator.userAgent.indexOf('Macintosh') > -1 && 'ontouchend' in document)
    );
};
